import React, { FC } from 'react';
import { useTranslation } from '@wix/wix-i18n-config';
import { ArrowDownRight } from '@wix/wix-ui-icons-common';

import { BLANK_TEMPLATE_META_SITE_ID } from '../../config';
import { useBiLogger } from '../../contexts/BILoggerContext';
import { generateEditUrl } from '../../utils/generateEditUrl';
import { TextButton } from '@wix/design-system';
import s from './BlankCanvasButton.scss';
import cs from 'classnames';

type Type = {
  dataHook?: string;
  onClick?: () => void;
  className?: string;
};

export const BlankCanvasButton: FC<Type> = (props) => {
  const { t } = useTranslation();
  const biLogger = useBiLogger();
  const onTryBlankCanvasButtonClick = () => {
    biLogger.reportEditTemplate({
      templateId: BLANK_TEMPLATE_META_SITE_ID,
      buttonVersion: 'Blank Canvas Entry Point',
      slug: '3217',
    });
  };

  const editBlankTemplateUrl = generateEditUrl({
    metaSiteId: BLANK_TEMPLATE_META_SITE_ID,
  });

  return (
    <TextButton
      dataHook={props.dataHook}
      underline="always"
      suffixIcon={<ArrowDownRight className={s.suffix} />}
      skin="dark"
      as="a"
      target="_blank"
      className={cs(s.root, props.className)}
      href={editBlankTemplateUrl}
      onClick={onTryBlankCanvasButtonClick}
    >
      {t('app.new.button.startWithBlankCanvas')}
    </TextButton>
  );
};
